export default __webpack_public_path__ + "static/media/shape-L.f9ed52de.svg";